import Big from 'big.js';

import { InsuranceProduct } from 'app/model/product/InsuranceProduct';

/**
 * Карточный продукт
 */
export class CardProduct {
    /**
     * Код (идентификатор) группы условий
     */
    id: string;

    /**
     * Код продукта
     */
    code: string;

    /**
     * Наименование продукта
     */
    name: string;

    /**
     * Минимальная предоставляемая сумма
     */
    minAmount: Big;

    /**
     * Максимальная предоставляемая сумма
     */
    maxAmount: Big;

    /**
     * Максимальная предоставляемая сумма для индивидуальных предпринимателей
     */
    soleTradersMaxAmount: Big;

    /**
     * Максимальная предоставляемая сумма для самозанятых
     */
    selfEmployedMaxAmount: Big;

    /**
     * Трёхбуквенный код валюты
     */
    currency: string;

    /**
     * Основная ставка
     */
    rate: Big;

    /**
     * Процент от суммы задолженности по основному долгу
     */
    minInterestRate: Big;

    /**
     * Срок предоставления (месяцы)
     */
    grantTerm: number;

    /**
     * Срок погашения (месяцы)
     */
    paymentTerm: number;

    /**
     * Страховые продукты
     */
    insurance: Array<InsuranceProduct>;

    /**
     * Признак обязательности выбора страховки
     */
    insuranceRequired: boolean;

    /**
     * Флаг значения по-умолчанию для поля "оформить со страховкой"
     */
    insuranceEnabled: boolean;

    constructor(
        id: string,
        code: string,
        name: string,
        minAmount: Big,
        maxAmount: Big,
        soleTradersMaxAmount: Big,
        selfEmployedMaxAmount: Big,
        currency: string,
        rate: Big,
        grantTerm: number,
        paymentTerm: number,
        insurance: Array<InsuranceProduct>,
        insuranceRequired: boolean,
        insuranceEnabled: boolean,
        minInterestRate: Big,
    ) {
        this.id = id;
        this.code = code;
        this.name = name;
        this.minAmount = minAmount;
        this.maxAmount = maxAmount;
        this.soleTradersMaxAmount = soleTradersMaxAmount;
        this.selfEmployedMaxAmount = selfEmployedMaxAmount;
        this.currency = currency;
        this.rate = rate;
        this.grantTerm = grantTerm;
        this.paymentTerm = paymentTerm;
        this.insurance = insurance;
        this.insuranceRequired = insuranceRequired;
        this.insuranceEnabled = insuranceEnabled;
        this.minInterestRate = minInterestRate;
    }

    static deserialize(data: any) {
        return new CardProduct(
            data.id,
            data.code,
            data.name,
            new Big(data.minAmount),
            new Big(data.maxAmount),
            new Big(data.soleTradersMaxAmount),
            new Big(data.selfEmployedMaxAmount),
            data.currency,
            new Big(data.rate),
            data.grantTerm,
            data.paymentTerm,
            data.insurance.map(InsuranceProduct.deserialize),
            data.insuranceRequired,
            data.insuranceEnabled,
            data.minInterestRate,
        );
    }
}
